import { render } from "./BackIcon.vue?vue&type=template&id=3f12fe5a&scoped=true"
import script from "./BackIcon.vue?vue&type=script&lang=js"
export * from "./BackIcon.vue?vue&type=script&lang=js"

import "./BackIcon.vue?vue&type=style&index=0&id=3f12fe5a&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f12fe5a"]])

export default __exports__